import { Component, ChangeDetectionStrategy } from "@angular/core";
import { environment } from "../../../../../../environments/environment";
import { CoreMediaContentRendererComponent } from "../coremedia-content-renderer/coremedia-content-renderer";

/**
 * 404 page. Renders the CoreMedia channel configured via `environment.notFound`,
 * resolved to the current locale (with fallback) by the backend. Shows a minimal static
 * fallback text if no channel is configured for this environment yet.
 */
@Component({
  selector: "claas-not-found-page",
  template: `
    @if (notFoundChannelId) {
      <claas-coremedia-content-renderer
        [contentId]="notFoundChannelId"
        [localized]="true"
        [siteName]="notFoundSiteName"
      />
    } @else {
      <p>Page not found.</p>
    }
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CoreMediaContentRendererComponent],
})
export class NotFoundPageComponent {
  protected readonly notFoundChannelId = environment.notFound.channelId;
  protected readonly notFoundSiteName = environment.notFound.siteName;
}
